import type { Nullable } from "@shared-kernel/core/types/nullable";

// Corps de toute réponse d'erreur de l'API. detail est une phrase en français écrite par l'API pour l'utilisateur ;
// null pour une erreur générique, l'écran garde alors son propre message.
export interface ApiErrorBody {
  status: number;
  code: string;
  detail: Nullable<string>;
  // Chemins pointés dans le body JSON de la requête (ex. "email", "address.city"), qui partagent le detail
  fields: string[];
}

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null && !Array.isArray(value);

const isNullableString = (value: unknown): value is Nullable<string> => value === null || typeof value === "string";

// Un ancien format, une page HTML d'un proxy ou un body vide ne passent pas : l'appelant retombe sur son message
export const isApiErrorBody = (value: unknown): value is ApiErrorBody =>
  isRecord(value) &&
  typeof value["status"] === "number" &&
  typeof value["code"] === "string" &&
  isNullableString(value["detail"]) &&
  Array.isArray(value["fields"]) &&
  value["fields"].every(field => typeof field === "string");

export class ApiError extends Error {
  public constructor(
    message: string,
    public readonly body: ApiErrorBody,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

// error est ce que rejette un unwrap() : le body d'erreur de l'API, ou une erreur sans body (session, réseau)
export const apiErrorMessage = (error: unknown, fallback: string): string => (isApiErrorBody(error) && error.detail) || fallback;
